module.exports = __webpack_public_path__ + "static/media/snapshot2a.7c454620.png";